import { envMap } from "./constants";

const urlObject = {
  [envMap.PRODUCTION]: {
    API_URL: "https://event-api.classplusapp.com",
  },
  [envMap.PREPROD]: {
    API_URL: "https://apip-gcp.classplusapp.com",
  },
  [envMap.STAGING]: {
    API_URL: "https://apip-gcp.classplusapp.com",
  },
};

export const getApiBaseURL = (env = envMap.STAGING) => {
    if (urlObject[env]) {
      return urlObject[env].API_URL;
    }
    console.log(`${env} is not a valid environment, calling stag env`);
    return urlObject[envMap.STAGING].API_URL;
};
